export const apiBaseURL = {
  TASK_LIST: '/taskList',
  TASK: '/task',
  TASK_ACTIVITY_MEMBERS: '/taskParticipantsList',
  TASK_ACTIVITY: '/activity',
  TASK_ACTIVITY_CALLHISTORY: '/taskParticipantActivityHistory',
  TASK_ACTIVITY_REPORT: '/taskParticipantsActivityListReport',
  PARTICIPANTCLASS_ACTION: '/participantClass',
  PARTICIPANT_ACTION: '/participants',
  DEPARTMENTS_ACTION: '/memberDepartment',
  DESIGNATIONS_ACTION: '/memberDesignation',
  ZONE_ACTION: '/participantZone',
  EVENTS_ACTION:'/events',
  MEMBERS_ACTION: '/members',
  ORGANIZATION_ACTION: '/company'
};

export const taskListActionType = {
  FETCH_TASKS: 'FETCH_TASKS'
};

export const taskActivityActionType = {
  FETCH_ACTIVITY_MEMBERS: 'FETCH_ACTIVITY_MEMBERS',
  FETCH_ACTIVITY_SUCCESS: 'FETCH_ACTIVITY_SUCCESS',
  FETCH_ACTIVITY_CALLHISTORY: 'FETCH_ACTIVITY_CALLHISTORY',
  FETCH_ACTIVITY_CALLHISTORY_API: 'FETCH_ACTIVITY_CALLHISTORY_API'
};

export const taskActivityReportActionType = {
  FETCH_ACTIVITY_REPORT: 'FETCH_ACTIVITY_REPORT'
};

export const participantActionType = {
    FETCH_PARTICIPANTS_ALL: 'FETCH_PARTICIPANTS_ALL',
    FETCH_PARTICIPANTS_SUCCESS: 'FETCH_PARTICIPANTS_SUCCESS'
};

export const participantClassActionType = {
    FETCH_PARTICIPANTCLASS_ALL: 'FETCH_PARTICIPANTCLASS_ALL',
    FETCH_PARTICIPANTCLASS_SUCCESS: 'FETCH_PARTICIPANTCLASS_SUCCESS'
}

export const departmentActionType = {
    FETCH_DEPARTMENTS_ALL: 'FETCH_DEPARTMENTS_ALL',
    FETCH_DEPARTMENTS_SUCCESS: 'FETCH_DEPARTMENTS_SUCCESS'
}

export const eventActionType = {
  FETCH_EVENTS_ALL: 'FETCH_EVENTS_ALL',
  FETCH_EVENTS_SUCCESS: 'FETCH_EVENTS_SUCCESS',
  FETCH_EVENTS_LOADING: 'FETCH_EVENTS_LOADING',
  FETCH_EVENTS_ERROR: 'FETCH_EVENTS_ERROR'
}

export const zoneActionType = {
    FETCH_ZONES_ALL: 'FETCH_ZONES_ALL',
    FETCH_ZONES_SUCCESS: 'FETCH_ZONES_SUCCESS'
}

export const designationActionType = {
    FETCH_DESIGNATIONS_ALL: 'FETCH_DESIGNATIONS_ALL',
    FETCH_DESIGNATIONS_SUCCESS: 'FETCH_DESIGNATIONS_SUCCESS'
}

export const Tokens = {
  ADMIN: 'auth_token',
  USER: 'user',
  FIRST_NAME: 'first_name',
  LAST_NAME: 'last_name',
  IMAGE: 'image',
  REGISTER_USER: 'register_user',
  GET_PERMISSIONS: 'get_permissions',
  USER_IMAGE_URL: 'user_image_url',
  UPDATED_EMAIL: 'updated_email',
  UPDATED_FIRST_NAME: 'updated_first_name',
  UPDATED_LAST_NAME: 'updated_last_name',
  LANGUAGE: 'language',
  UPDATED_LANGUAGE: 'updated_language'
};

export const errorMessage = {
  TOKEN_NOT_PROVIDED: 'Token not provided',
  TOKEN_EXPIRED: 'Token has expired',
  TOKEN_INVALID: 'Could not decode token: Error while decoding to JSON: Syntax error',
  TOKEN_INVALID_SIGNATURE: 'Token Signature could not be verified.'
};

export const activityStatusOptions = [
  { label: 'Open', value: 0 },
  { label: 'Closed', value: 1 },
  { label: 'In Progress', value: 2 },
  { label: 'Rejected', value: 3 }
];

export const callActivitySuccessMsg = 'Call Log Recorded Successfully.!';

export const memberActionType = {
    FETCH_MEMBERS_ALL: 'FETCH_MEMBERS_ALL',
    FETCH_MEMBERS_SUCCESS: 'FETCH_MEMBERS_SUCCESS',
    FETCH_MEMBERS_LOADING: 'FETCH_MEMBERS_LOADING',
    FETCH_MEMBERS_ERROR: 'FETCH_MEMBERS_ERROR'
};

export const organizationActionType = {
    FETCH_ORGANIZATIONS_ALL: 'FETCH_ORGANIZATIONS_ALL',
    FETCH_ORGANIZATIONS_SUCCESS: 'FETCH_ORGANIZATIONS_SUCCESS'
};
